// src/features/inventory/hooks/useScanners.js
import { useState, useCallback } from 'react';
import { scannersAPI } from '../services/scanners';
import { useApi } from '../../../hooks/api/useApi';

export function useScanners() {
  const [scanners, setScanners] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchScanners = useCallback(async () => {
    const result = await execute(() => scannersAPI.getScanners());
    if (result.success) setScanners(result.data.data || []);
    return result;
  }, [execute]);

  const createScanner = useCallback(async (data) => {
    const result = await execute(() => scannersAPI.createScanner(data));
    if (result.success) setScanners(prev => [...prev, result.data.data]);
    return result;
  }, [execute]);

  const updateScanner = useCallback(async (scannerId, data) => {
    const result = await execute(() => scannersAPI.updateScanner(scannerId, data));
    if (result.success) {
      setScanners(prev => prev.map(s => s.scanner_id === scannerId ? result.data.data : s));
    }
    return result;
  }, [execute]);

  const deleteScanner = useCallback(async (scannerId) => {
    const result = await execute(() => scannersAPI.deleteScanner(scannerId));
    if (result.success) setScanners(prev => prev.filter(s => s.scanner_id !== scannerId));
    return result;
  }, [execute]);

  return { scanners, loading, error, clearError, fetchScanners, createScanner, updateScanner, deleteScanner };
}
